module.exports = __webpack_public_path__ + "img/brand (4).8738598d.svg";